{
  "loading": "Loading…",
  "save": "Save",
  "saving": "Saving…",
  "cancel": "Cancel",
  "close": "Close",
  "confirm": "Confirm",
  "back": "Back",
  "next": "Next",
  "search": "Search",
  "filter": "Filters",
  "clear": "Clear",
  "viewAll": "View all",
  "retry": "Try again",
  "yes": "Yes",
  "no": "No",
  "none": "None",
  "empty": "Nothing to show yet",
  "saved": "Saved",
  "language": "Language",
  "languageDescription": "Choose the language used across BidNova Auctions, including your emails and notifications.",
  "languageSaved": "Language updated",
  "loadingLabel": "Loading",
  "retrying": "Retrying…",
  "nothingToShow": "Nothing to show yet.",
  "errorTitle": "Something went wrong",
  "errorBody": "We couldn't load this right now.",
  "viewOrder": "View order",
  "signIn": "Sign in",
  "signOut": "Sign out"
}
